import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class AddressTypeService{
    
    constructor(private http: HttpClient) {
    }

    addAccounAddressType(data){
      return this.http.post<any>( `${environment.coreUrl}Type`, data);
    }
}